import * as ActionConfigurationManager from './config.actions'

export const saveUrlParams = ActionConfigurationManager.SAVE_URL_PARAMS